import React, {useContext} from 'react';
import BaseComponent, {AjaxParam} from '@components/base/BaseComponent/BaseComponent';
import ContextSASSLoginProviderVO from "../valueObjects/ContextSASSLoginProviderVO";
import {_validateEmail} from "../common/helpers/HelperValidator";
import {__t} from "../common/lang/text-resource";
import {_scorePassword} from "../common/helpers/HelperFunc";
import messages from "../common/lang/messages";

const ContextSASSLogin = React.createContext({});


/**
 * @class ContextSASSLoginProvider
 *
 */
class ContextSASSLoginProvider extends BaseComponent {

	static SASSLoginStepExisting = 'SASSLoginStepExisting';
	static SASSLoginStepNew = 'SASSLoginStepNew';
	static SASSLoginStepCheck = 'SASSLoginStepCheck';

	state = {
		contextData: new ContextSASSLoginProviderVO({}),
		inputErrors: {
			email: '',
			name: '',
			phone: '',
			password: '',
			passwordRepeat: '',
		}
	};

	sessionStorageKey = '';

	constructor(props) {
		super(props);

		this.sessionStorageKey = !!props.sessionKey ? props.sessionKey : contextName;

		const contextName = 'contextSASSLogin';
		this.componentName = SHVO.pageState.componentData[contextName].componentName;
		this.componentToken = SHVO.pageState.componentData[contextName].componentToken;

		const savedState = sessionStorage.getItem(this.sessionStorageKey);
		this.state.contextData = !!savedState ? new ContextSASSLoginProviderVO(JSON.parse(savedState)) : new ContextSASSLoginProviderVO(props.data.componentData);

	}

	setSessionState = (newState) => {
		this.setState(newState, () => {
			sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(this.state.contextData));
		});
	}

	email = (value) => {
		const state = this.state;
		if (typeof value === 'undefined') {
			return state.contextData.email;
		}
		state.contextData.email = value;
		this.setSessionState({...state});
	}

	password = (value) => {
		const state = this.state;
		if (typeof value === 'undefined') {
			return state.contextData.password;
		}
		state.contextData.password = value;
		this.setState({...state});
	}

	name = (value) => {
		const state = this.state;
		if (typeof value === 'undefined') {
			return state.contextData.name;
		}
		state.contextData.name = value;
		this.setSessionState({...state});
	}

	phoneCode = (value) => {
		const state = this.state;
		if (typeof value === 'undefined') {
			return state.contextData.phoneCode;
		}
		state.contextData.phoneCode = value;
		this.setSessionState({...state});
	}

	phone = (value) => {
		const state = this.state;
		if (typeof value === 'undefined') {
			return state.contextData.phone;
		}
		state.contextData.phone = value;
		this.setSessionState({...state});
	}

	passwordRepeat = (value) => {
		const state = this.state;
		if (typeof value === 'undefined') {
			return state.contextData.passwordRepeat;
		}
		state.contextData.passwordRepeat = value;
		this.setSessionState({...state});
	}

	inputError = (key) => {
		const state = this.state;
		return state.inputErrors[key] ?? '';
	}

	submitEmail = () => {
		let hasError = false;

		const state = this.state;
		state.inputErrors.email = '';

		if (!_validateEmail(this.state.contextData.email)) {
			state.inputErrors.email = __t('Моля, въведете валиден имейл адрес!');
			hasError = true;
		}

		this.setSessionState({...state});

		if (hasError) {
			return;
		}

		const ap = new AjaxParam();
		ap.callbackSuccess = ({componentData}) => {
			const state = this.state;
			state.contextData = new ContextSASSLoginProviderVO(componentData);
			this.setSessionState({...state});
		};

		this.ajaxCall('ActionSubmitEmail', this.state.contextData, ap);
	}

	submitPassword = () => {

		if (this.isLoginDisabled()) {
			return;
		}

		const state = this.state;
		state.inputErrors.password = '';

		const ap = new AjaxParam();
		ap.callbackSuccess = ({componentData}) => {
			const state = this.state;
			state.contextData = new ContextSASSLoginProviderVO(componentData);
			this.setSessionState({...state});
		};
		ap.callbackError = ({componentErrors}) => {
			const state = this.state
			state.loading = false
			state.inputErrors.password = this.messages[componentErrors[0]]
			this.setState({...state})
		}

		this.ajaxCall('ActionSubmitPassword', this.state.contextData, ap);
	}

	submitRegister = () => {
		let hasError = false;

		const state = this.state;
		state.inputErrors.name = '';
		state.inputErrors.phoneCode = '';
		state.inputErrors.phone = '';
		state.inputErrors.password = '';
		state.inputErrors.passwordRepeat = '';

		const data = state.contextData;
		if (data.name === '') {
			hasError = true;
			state.inputErrors.name = __t('Моля, въведете име!');
		}
		if (data.phoneCode === '') {
			hasError = true;
			state.inputErrors.phoneCode = __t('Моля, въведете телефонен код!');
		}
		if (data.phone === '') {
			hasError = true;
			state.inputErrors.phone = __t('Моля, въведете телефон за връзка!');
		}
		if (data.password === '') {
			hasError = true;
			state.inputErrors.password = __t('Моля, въведете парола!');
		} else {
			const score = _scorePassword(data.password);
			if (score < 50) {
				state.inputErrors.password = __t('Слаба парола');
				hasError = true;
			}
		}
		if (data.passwordRepeat === '') {
			hasError = true;
			state.inputErrors.passwordRepeat = __t('Моля, въведете повторно паролата!');
		} else {
			if (data.password !== data.passwordRepeat) {
				state.inputErrors.passwordRepeat = __t('Паролите не съвпадат!');
				hasError = true;
			}
		}

		if (hasError) {
			this.setSessionState({...state});
			return;
		}


		const ap = new AjaxParam();
		ap.callbackSuccess = ({componentData}) => {
			const state = this.state;
			state.contextData = new ContextSASSLoginProviderVO(componentData);
			this.setSessionState({...state});
		};

		this.ajaxCall('ActionSubmitRegister', this.state.contextData, ap);
	}

	actionFPEmailSend = () => {
		if (this.isForgottenPasswordDisabled()) {
			return;
		}
		const ap = new AjaxParam();
		ap.callbackSuccess = ({componentData}) => {
			const state = this.state;
			state.contextData = new ContextSASSLoginProviderVO(componentData);
			this.setSessionState({...state});
		};

		this.ajaxCall('ActionFPMailSend', this.state.contextData, ap);
	}

	actionBack = () => {
		const state = this.state;
		state.contextData.isExisting = false;
		state.contextData.isChecked = false;
		state.contextData.isFPMailSent = false;
		state.contextData.email = "";

		sessionStorage.removeItem(this.sessionStorageKey);

		this.setSessionState({...state});
	}

	returnStep = () => {
		if (!this.state.contextData.isChecked) {
			return ContextSASSLoginProvider.SASSLoginStepCheck;
		}
		if (this.state.contextData.isExisting) {
			return ContextSASSLoginProvider.SASSLoginStepExisting;
		}
		return ContextSASSLoginProvider.SASSLoginStepNew;
	}

	phoneCodes = () => {
		return this.state.contextData.phoneCodes;
	}

	isFPMailSent = () => {
		return this.state.contextData.isFPMailSent;
	}

	isLoginDisabled = () => {
		return this.state.contextData.loginDisabled;
	}

	isForgottenPasswordDisabled = () => {
		return this.state.contextData.forgotPasswordDisabled;
	}

	render() {
		return (
		  <ContextSASSLogin.Provider value={{
			  email: this.email,
			  password: this.password,
			  name: this.name,
			  phoneCode: this.phoneCode,
			  phone: this.phone,
			  passwordRepeat: this.passwordRepeat,
			  inputError: this.inputError,
			  submitEmail: this.submitEmail,
			  submitPassword: this.submitPassword,
			  submitRegister: this.submitRegister,
			  actionFPEmailSend: this.actionFPEmailSend,
			  actionBack: this.actionBack,
			  returnStep: this.returnStep,
			  phoneCodes: this.phoneCodes,
			  isFPMailSent: this.isFPMailSent,
			  isLoginDisabled: this.isLoginDisabled,
			  isForgottenPasswordDisabled: this.isForgottenPasswordDisabled,
		  }}>
			  {this.props.children}
		  </ContextSASSLogin.Provider>
		)
	}
}

/**
 *
 * @returns {ContextSASSLoginProvider}
 */
export const useContextSASSLogin = () => useContext(ContextSASSLogin);

export {ContextSASSLogin, ContextSASSLoginProvider};